import { gql } from '@apollo/client';

export const REMOVE_LEASING_INTEREST = gql`
  mutation removeLeasingInterest($interestTypeId: Int!) {
    removeLeasingInterest(interestTypeId: $interestTypeId) {
      commandId
    }
  }
`;
